import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import CircularProgress from "material-ui/CircularProgress";
import {
  counstructFilters,
  counstructCloudSearchFilters
} from "@services/dashboardResource";
import { Container, TranscriptsLoaderStyle } from "@layout/DashboardPage";
import { Subheader, Tab, ActiveTab } from "@layout/Subheader";
import { IS_CLOUDSEARCH_ENABLED } from "@config/config";
import { Pagination } from "@atoms";
import { PageTemplate, AttendeePageTemplate } from "@templates";
import { DashboardTable, AttendeeDashboard } from "@organisms";
import { DashboardFilters } from "@molecules";
import messages from "./messages";

const DASHBOARD_UPDATE_INTERVAL = 120000;

export default class DashboardPage extends PureComponent {
  static propTypes = {
    getDashboardList: PropTypes.func.isRequired,
    getCloudSearchTranscriptsList: PropTypes.func,
    list: PropTypes.array,
    isFetching: PropTypes.bool,
    currentPage: PropTypes.number,
    numberPerPage: PropTypes.number,
    totalPages: PropTypes.number,
    showTranscripts: PropTypes.bool,
    isCloudSearchResults: PropTypes.bool,
    resubmitTranscript: PropTypes.func,
    resetConference: PropTypes.func
  };

  static defaultProps = {
    isFetching: false,
    currentPage: 1,
    numberPerPage: null,
    totalPages: null,
    list: [],
    showTranscripts: false
  };

  get filters() {
    return counstructFilters(this.props);
  }

  get currentPage() {
    return this.props.currentPage;
  }

  get numberPerPage() {
    return this.props.numberPerPage;
  }

  get cloudSearchFilters() {
    return counstructCloudSearchFilters(this.props);
  }

  get subheader() {
    return this.props.showTranscripts ? (
      <Subheader>
        <Tab to="/">
          <FormattedMessage {...messages.conferences} />
        </Tab>
        <ActiveTab>
          <FormattedMessage {...messages.transcripts} />
        </ActiveTab>
      </Subheader>
    ) : (
      <Subheader>
        <ActiveTab>
          <FormattedMessage {...messages.conferences} />
        </ActiveTab>
        <Tab to="/transcripts">
          <FormattedMessage {...messages.transcripts} />
        </Tab>
      </Subheader>
    );
  }

  componentDidMount() {
    const { getDashboardList } = this.props;

    getDashboardList(this.currentPage, this.numberPerPage, this.filters);
    // we're on "Conferences" tab
    if (this.props.path === "/") {
      /** Reset conference state when the page is loaded, just in case there is still conference data in the state from a previous page. */
      this.props.resetConference();

      const tick = async () => {
        await getDashboardList(
          this.currentPage,
          this.numberPerPage,
          this.filters
        );
        this.intervalId = setTimeout(tick, DASHBOARD_UPDATE_INTERVAL);
      };
      this.intervalId = setTimeout(tick, DASHBOARD_UPDATE_INTERVAL);
    }
  }

  componentWillUnmount() {
    this.intervalId && clearTimeout(this.intervalId);
  }

  render() {
    const {
      currentPage,
      numberPerPage,
      getDashboardList,
      getCloudSearchTranscriptsList,
      totalPages,
      list,
      isFetching,
      showTranscripts,
      isAttendee
    } = this.props;

    // eslint-disable-next-line
    if (isAttendee)
      return (
        <AttendeePageTemplate>
          <Container centered>
            {IS_CLOUDSEARCH_ENABLED && (
              <DashboardFilters
                {...this.props}
                target="attendee"
                applyFilter={() => {
                  getCloudSearchTranscriptsList(this.cloudSearchFilters);
                }}
              />
            )}
            {totalPages > 1 && (
              <Pagination
                id="dashboard-table-pagination"
                current={currentPage}
                total={totalPages}
                onChange={pageNumber => {
                  getDashboardList(pageNumber, numberPerPage, this.filters);
                }}
              />
            )}
          </Container>
          {isFetching ? (
            <CircularProgress style={TranscriptsLoaderStyle} />
          ) : (
            <AttendeeDashboard
              {...this.props}
              id="attendee-dashboard"
              list={list}
              sortByOrder={() => {
                getDashboardList(0, numberPerPage, this.filters);
              }}
            />
          )}
        </AttendeePageTemplate>
      );

    return (
      <PageTemplate
        title={<FormattedMessage {...messages.title} />}
        subheader={this.subheader}
      >
        <Container>
          <DashboardFilters
            {...this.props}
            applyFilter={() => {
              getDashboardList(0, numberPerPage, this.filters);
            }}
          />
          {totalPages > 1 && (
            <Pagination
              id="dashboard-table-pagination"
              current={currentPage}
              total={totalPages}
              onChange={pageNumber => {
                getDashboardList(pageNumber, numberPerPage, this.filters);
              }}
            />
          )}
        </Container>
        <DashboardTable
          {...this.props}
          id="dashboard-table"
          showTranscripts={showTranscripts}
          list={list}
          sortByOrder={() => {
            getDashboardList(0, numberPerPage, this.filters);
          }}
        />
        {isFetching && <CircularProgress style={TranscriptsLoaderStyle} />}
      </PageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/DashboardPage/DashboardPage.js